// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"398":"fcb76262","709":"f13203db","811":"c8ed212a"}[chunkId] + ".chunk.css";
};